export default function TrustSection() {
  return (
    <section className="w-full bg-accent-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          {/* Section header */}
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block px-4 py-1.5 rounded-full bg-background-50 text-foreground-600 text-xs font-semibold mb-4">
              Why Choose Us
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              Why CSSBuy Spreadsheets?
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              We make China shopping easier with verified spreadsheets, daily updates, and trusted agent links.
            </p>
          </div>

          {/* Feature cards with images */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            <div className="bg-background-50 rounded-xl overflow-hidden">
              <div className="w-full aspect-[4/3] overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Green%20checkmark%20stamp%20on%20white%20paper%20document%20with%20magnifying%20glass%20beside%20it%2C%20verification%20and%20approval%20concept%2C%20clean%20professional%20desk%20setting%2C%20natural%20office%20lighting%2C%20trust%20and%20credibility%20theme&width=600&height=450&seq=trust-verified-v2&orientation=landscape"
                  alt="Verified Links"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-5 md:p-6 text-center">
                <h4 className="font-heading text-base font-semibold text-foreground-900 mb-2">Verified Links</h4>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  Every spreadsheet link is manually checked and verified before being listed. No dead links, no scam pages.
                </p>
              </div>
            </div>
            <div className="bg-background-50 rounded-xl overflow-hidden">
              <div className="w-full aspect-[4/3] overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Wall%20calendar%20with%20multiple%20dates%20circled%20in%20red%20marker%20hanging%20on%20cork%20board%2C%20pinned%20notes%20and%20reminders%2C%20productivity%20and%20organization%20concept%2C%20warm%20home%20office%20setting%2C%20planning%20and%20consistency%20theme&width=600&height=450&seq=trust-updates-v2&orientation=landscape"
                  alt="Daily Updates"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-5 md:p-6 text-center">
                <h4 className="font-heading text-base font-semibold text-foreground-900 mb-2">Daily Updates</h4>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  Our spreadsheet database is refreshed every day with the latest finds and trending items from China.
                </p>
              </div>
            </div>
            <div className="bg-background-50 rounded-xl overflow-hidden">
              <div className="w-full aspect-[4/3] overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Ceramic%20piggy%20bank%20next%20to%20a%20colorful%20folded%20cashmere%20scarf%20and%20small%20shopping%20bag%2C%20saving%20money%20while%20shopping%20concept%2C%20bright%20windowsill%20setting%20with%20sunlight%2C%20smart%20budget%20lifestyle%20photography&width=600&height=450&seq=trust-budget-v2&orientation=landscape"
                  alt="Budget Finds"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-5 md:p-6 text-center">
                <h4 className="font-heading text-base font-semibold text-foreground-900 mb-2">Budget Finds</h4>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  Discover affordable products across all categories. From budget sneakers to luxury-inspired accessories.
                </p>
              </div>
            </div>
            <div className="bg-background-50 rounded-xl overflow-hidden">
              <div className="w-full aspect-[4/3] overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Miniature%20padlock%20with%20heart%20keyhole%20resting%20on%20soft%20pink%20tissue%20paper%20inside%20open%20cardboard%20shipping%20box%2C%20safe%20delivery%20and%20protection%20concept%2C%20ecommerce%20packaging%20photography%2C%20gentle%20window%20light%2C%20secure%20shopping%20theme&width=600&height=450&seq=trust-safe-v2&orientation=landscape"
                  alt="Safe Shopping"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-5 md:p-6 text-center">
                <h4 className="font-heading text-base font-semibold text-foreground-900 mb-2">Safe Shopping</h4>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  We provide risk-aware guidance so you can shop with confidence. Learn about QC, shipping, and buyer protection.
                </p>
              </div>
            </div>
          </div>

          {/* Stats row */}
          <div className="mt-12 md:mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
            <div>
              <div className="font-heading text-3xl md:text-5xl font-bold text-primary-600">1000+</div>
              <div className="mt-1 text-xs md:text-sm text-foreground-500">Verified Items</div>
            </div>
            <div>
              <div className="font-heading text-3xl md:text-5xl font-bold text-accent-600">14</div>
              <div className="mt-1 text-xs md:text-sm text-foreground-500">Categories</div>
            </div>
            <div>
              <div className="font-heading text-3xl md:text-5xl font-bold text-secondary-600">4</div>
              <div className="mt-1 text-xs md:text-sm text-foreground-500">Trusted Agents</div>
            </div>
            <div>
              <div className="font-heading text-3xl md:text-5xl font-bold text-primary-600">2026</div>
              <div className="mt-1 text-xs md:text-sm text-foreground-500">Updated Year</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}